<template>
    <div id="radar-control" 
        class="radar-control"
    >
        <v-select
            v-model="radar_angle_selected"
            :items="radar_angle_sliders"
            variant="outlined"
        />
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    export default {
        name: 'RadarControl',

        data() {
            return {
                radar_angle_selected: null
            }
        },

        computed: {
            ...mapGetters('emap', [
                'radar_id',
                'radar_angle',
                'radar_angle_options',
            ]),
            
            radar_angle_sliders() {
                return [...this.radar_angle_options].sort((a, b) => a - b)
            }
        },

        watch: {
            radar_angle_selected: {
                handler(new_angle) {
                    this.set_radar({ angle: new_angle })
                }
            }
        },

        mounted() {
            this.init_radar_angle_index()
        },

        methods: {
            ...mapMutations('emap', [
                'set_radar'
            ]),

            init_radar_angle_index() {
                this.radar_angle_selected = this.radar_angle_sliders[0];
            },
        },
    }
</script>

<style lang="scss" scoped>
    .radar-control {
        font-size: 12px;
    }
</style>

<style scoped>
    .radar-control >>> .v-select__selection--comma {
        color: white;
    }

    .radar-control >>> .v-icon.v-icon {
        color: white !important;
    }

    .radar-control >>> .v-input--is-label-active {
        color: white !important;
    }
</style>

